import type { IconNode } from '../types';

/**
 * @name chart-quadrant
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTMgM3YxOCIgLz4KICA8cGF0aCBkPSJNMyAxMmgxOCIgLz4KICA8cGF0aCBkPSJNMyAzdjE2YTIgMiAwIDAwMiAyaDE2IiAvPgogIDxjaXJjbGUgY3g9IjE3LjUiIGN5PSI1LjUiIHI9IjAuNSIgZmlsbD0iY3VycmVudENvbG9yIiAvPgogIDxjaXJjbGUgY3g9IjE5LjUiIGN5PSIxNi41IiByPSIwLjUiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KICA8Y2lyY2xlIGN4PSI3LjUiIGN5PSIxNi41IiByPSIwLjUiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KICA8Y2lyY2xlIGN4PSI3LjUiIGN5PSI3LjUiIHI9IjAuNSIgZmlsbD0iY3VycmVudENvbG9yIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/chart-quadrant
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ChartQuadrant: IconNode = [
  ['path', { d: 'M13 3v18' }],
  ['path', { d: 'M3 12h18' }],
  ['path', { d: 'M3 3v16a2 2 0 002 2h16' }],
  ['circle', { cx: '17.5', cy: '5.5', r: '0.5', fill: 'currentColor' }],
  ['circle', { cx: '19.5', cy: '16.5', r: '0.5', fill: 'currentColor' }],
  ['circle', { cx: '7.5', cy: '16.5', r: '0.5', fill: 'currentColor' }],
  ['circle', { cx: '7.5', cy: '7.5', r: '0.5', fill: 'currentColor' }],
];

export default ChartQuadrant;
